export default o =>
  typeof o === 'object' && Object(o) === o && Object.getPrototypeOf(o) === Object.prototype;
